import { func, object } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import getContext from 'recompose/getContext'
import withState from 'recompose/withState'
import withHandlers from 'recompose/withHandlers'

import CopySettingView from './CopySetting'

const CopySetting = scope(
  consumeProps({
    extendRange: func.isRequired,
  }),
  getContext({
    server: object.isRequired,
  }),

  withState('value', 'onChange', ''),

  withHandlers({
    copyRange: ({ extendRange, server: { get }, value }) => async () => {
      const { data: priceRanges } = await get({
        url: 'api/model/priceRanges',
        query: {
          query: {
            key: value,
          },
        },
      })

      if (typeof priceRanges[0] === 'object') {
        const fromRange = priceRanges[0].range
        extendRange({ fromRange })
      }
    },
  }),

  exposeProps([
    'value',
    'onChange',

    'copyRange',
  ]),
)(CopySettingView)

CopySetting.displayName = 'CopySetting'

export default CopySetting



// WEBPACK FOOTER //
// ./src/components/RangeEditor/CopySetting/index.js